<template>
  <v-container :fluid="true">
    <v-card :flat="true">
      <v-card-title class="mb-3 text-h5 font-weight-bold">{{
        wordList.lbl_area_lot_setting
      }}</v-card-title>
    </v-card>
    <v-tabs v-model="tab" hide-slider>
      <v-tab
        :class="tab === 'formTab' ? 'tab_active' : 'tab_inactive'"
        value="formTab"
      >
        {{ wordList.lbl_area_regist_title }}
      </v-tab>
      <v-tab
        :class="[tab === 'area_regist' ? 'tab_active' : 'tab_inactive', 'ml-2']"
        value="area_regist"
      >
        {{ wordList.lbl_delivery_lot_regist }}
      </v-tab>
      <v-tab
        :class="[tab === 'delivery_lot_regist' ? 'tab_active' : 'tab_inactive', 'ml-2']"
        value="delivery_lot_regist"
      >
        {{ wordList.lbl_delivery_lot_list }}
      </v-tab>
    </v-tabs>
      <!-- tab1 -->
    <v-tabs-window v-model="tab">
      <!-- 「エリア登録・編集」タブ -->
      <v-tabs-window-item value="formTab">
        <v-card
          v-if="
            !displayInputDialog &&
            !displayConfirmDialog &&
            !displayCompletedDialog
          "
          :flat="true"
        >
          <form>
            <v-card :flat="true">
              <v-card-text class="text-red pb-0">
                {{ wordList.lbl_shop_select }}
              </v-card-text>
              <v-card-text class="text-red py-0">
                {{ wordList.lbl_next_delivery_lot_regist }}
              </v-card-text>
              <v-card-text class="pt-0">
                <v-row density="compact" class="mt-3">
                  <!-- チェーンコード -->
                  <v-col v-if="chainViewFlag" sm="6" md="4" class="py-0">
                    <v-autocomplete
                      v-model="chainSelectValues"
                      density="compact"
                      :label="wordList.lbl_chain_name"
                      :items="chainListItems"
                      item-title="name"
                      item-value="chain_code"
                      :placeholder="wordList.plc_selectbox"
                      :error-messages="errorMessages"
                      :no-data-text="wordList.lbl_no_data_text"
                      bg-color="white"
                      return-object
                      variant="outlined"
                      persistent-placeholder
                      @update:model-value="onChangeChain"
                    ></v-autocomplete>
                  </v-col>
                  <!-- 店舗コード -->
                  <v-col cols="6" sm="6" md="4" class="py-0">
                    <v-autocomplete
                      v-model="shopSelectValues"
                      :items="shopListItems"
                      item-title="name"
                      item-value="shop_code"
                      :label="wordList.lbl_shop_name"
                      :placeholder="wordList.plc_selectbox"
                      :no-data-text="wordList.lbl_no_data_text"
                      density="compact"
                      return-object
                      variant="outlined"
                      persistent-placeholder
                      @update:model-value="onChangeShop"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </form>
          <!-- 一覧表示 -->
          <v-toolbar flat>
            <v-btn
              variant="elevated"
              color="primary"
              class="mb-2 ml-4 px-10"
              :disabled="!shopSelectValues || !shopSelectValues.shop_code"
              @click="onClickNewRegister"
            >
              {{ wordList.lbl_new_add }}
            </v-btn>
          </v-toolbar>
          <v-data-table
            v-if="shopSelectValues && shopSelectValues.shop_code"
            :items="listArea"
            :headers="tableHeaders"
            :no-data-text="wordList.lbl_no_data_text"
            hide-default-footer
            disable-pagination
          >
            <template #item.actions="{ item }">
              <div>
                <v-btn
                  variant="outlined"
                  color="primary"
                  class="my-2 ml-2"
                  size="x-small"
                  rounded="circle"
                  icon
                  @click="onClickEdit(item)"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
                <v-btn
                  variant="outlined"
                  color="red"
                  class="my-2 ml-2 mr-0"
                  size="x-small"
                  rounded="circle"
                  icon
                  @click="onClickDelete(item)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </div>
            </template>
          </v-data-table>
          <v-data-table
            v-if="!shopSelectValues || !shopSelectValues.shop_code"
            :headers="tableHeaders"
            :no-data-text="wordList.lbl_no_data_text"
            hide-default-footer
            disable-pagination
          >
          </v-data-table>
        </v-card>
        <v-card v-if="displayInputDialog && isWordListReady" :flat="true" class="mt-10">
          <Form v-slot="{ meta }">
            <v-card>
              <v-card-title class="mt-3 pb-5 text-h5 font-weight-bold">
                {{ wordList.lbl_area_regist }}
              </v-card-title>
              <v-card-text>
                <v-container>
                  <!-- チェーン名 -->
                  <v-row density="compact" v-if="chainViewFlag">
                    <v-col cols="4" class="font-weight-black">
                      <v-row align="center" dense
                        density="compact"
                          class="form-label-row mr-3 mb-3"
                        justify="end"
                      >
                        {{ wordList.lbl_chain_name }}
                        <ImportantChip></ImportantChip>
                      </v-row>
                    </v-col>
                    <v-col class="color_black">
                      {{ chainSelectValues.name }}
                    </v-col>
                  </v-row>
                  <!-- 店舗名 -->
                  <v-row density="compact">
                    <v-col cols="4" class="font-weight-black">
                      <v-row align="center" dense
                        density="compact"
                          class="form-label-row mr-3 mb-3"
                        justify="end"
                      >
                        {{ wordList.lbl_shop_name }}
                        <ImportantChip></ImportantChip>
                      </v-row>
                    </v-col>
                    <v-col class="color_black">
                      {{ shopSelectValues.name }}
                    </v-col>
                  </v-row>
                  <!-- エリア名 -->
                  <v-row density="compact">
                    <v-col cols="4" class="font-weight-black">
                      <v-row align="center" dense
                        density="compact"
                          class="form-label-row mr-3"
                        justify="end"
                      >
                        {{ wordList.lbl_area_name }}
                        <ImportantChip></ImportantChip>
                      </v-row>
                    </v-col>
                    <v-col cols="6">
                      <Field
                        v-slot="{ field, errors }"
                        :name="wordList.lbl_area_name"
                        rules="required|max:50"
                        v-model="deliveryAreaInput.area_name"
                      >
                        <v-text-field
                          :model-value="field.value ?? deliveryAreaInput.area_name"
                          :placeholder="wordList.plc_area_name"
                          density="compact"
                          variant="outlined"
                          :error-messages="errors"
                          @update:model-value="
                            (val) => {
                              field.onChange(val);
                              deliveryAreaInput.area_name = val;
                            }
                          "
                          @blur="field.onBlur"
                        ></v-text-field>
                      </Field>
                    </v-col>
                  </v-row>
                  <!-- エリア名(カナ) -->
                  <v-row density="compact">
                    <v-col cols="4" class="font-weight-black">
                      <v-row align="center" dense
                        density="compact"
                          class="form-label-row mr-3"
                        justify="end"
                      >
                        {{ wordList.lbl_area_name_kana }}
                        <ImportantChip></ImportantChip>
                      </v-row>
                    </v-col>
                    <v-col cols="6">
                      <Field
                        v-slot="{ field, errors }"
                        :name="wordList.lbl_area_name_kana"
                        rules="required|max:100|regex:^[ァ-ヶー・0-9０-９]+$"
                        v-model="deliveryAreaInput.area_name_kana"
                      >
                        <v-text-field
                          :model-value="field.value ?? deliveryAreaInput.area_name_kana"
                          :placeholder="wordList.plc_area_name_kana"
                          density="compact"
                          variant="outlined"
                          :error-messages="errors"
                          @update:model-value="
                            (val) => {
                              field.onChange(val);
                              deliveryAreaInput.area_name_kana = val;
                            }
                          "
                          @blur="field.onBlur"
                        ></v-text-field>
                      </Field>
                    </v-col>
                  </v-row>
                  <!-- 支払方法 -->
                  <!--
                  <v-row density="compact">
                    <v-col cols="4" class="font-weight-black">
                      <v-row align="center" dense
                        density="compact"
                          class="form-label-row mr-3"
                        justify="end"
                      >
                        {{ wordList.lbl_payment_method }}
                        <ImportantChip></ImportantChip>
                      </v-row>
                    </v-col>
                    <v-col cols="6">
                      <Field
                        v-slot="{ errors }"
                        name="paymentMethod"
                        rules="required"
                      >
                        <v-autocomplete
                          v-model="deliveryAreaInput.payment_method"
                          :items="paymentMethodItems"
                          item-title="payment_method"
                          item-value="payment_method"
                          :placeholder="wordList.plc_selectbox"
                          :no-data-text="wordList.lbl_no_data_text"
                          :error-messages="errors"
                          density="compact"
                          variant="outlined"
                          persistent-placeholder
                        ></v-autocomplete>
                      </Field>
                    </v-col>
                  </v-row>
                  -->
                  <!-- 受付可能終了時間 -->
                  <v-row dense>
                    <v-col cols="4" class="font-weight-black">
                      <v-row align="center"
                        dense
                          class="form-label-row mr-3"
                        justify="end"
                      >
                        {{ wordList.lbl_acceptable_end_time }}
                        <ImportantChip></ImportantChip>
                      </v-row>
                    </v-col>
                    <v-col cols="2">
                      <Field
                        v-slot="{ field, errors }"
                        :name="wordList.lbl_acceptable_end_time"
                        rules="required|time_format"
                        v-model="deliveryAreaInput.acceptable_end_time"
                      >
                        <v-text-field
                          :model-value="field.value ?? deliveryAreaInput.acceptable_end_time"
                          density="compact"
                          variant="outlined"
                          :placeholder="wordList.plc_acceptable_end_time"
                          :error-messages="errors"
                          @update:model-value="
                            (val) => {
                              field.onChange(val);
                              deliveryAreaInput.acceptable_end_time = val;
                            }
                          "
                          @blur="field.onBlur"
                        ></v-text-field>
                      </Field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>

              <v-card-actions class="justify-center">
                <v-btn
                  variant="flat"
                  color="return"
                  class="px-16"
                  @click="onClickInputCancel"
                >
                  <v-icon>mdi-arrow-left</v-icon>
                  {{ wordList.btn_return }}
                </v-btn>
                <v-btn
                  variant="flat"
                  color="primary"
                  class="px-16"
                  :disabled="!meta.valid"
                  @click="onClickOpenConfirmDialog"
                >
                  <v-icon>mdi-playlist-edit</v-icon>
                  {{ wordList.btn_regist_confirm }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </Form>
        </v-card>
        <!-- エリア登録確認ダイアログ { -->
        <v-card v-if="displayConfirmDialog" class="mt-10">
          <v-card>
            <v-card-title class="mt-3 pb-5 text-h5 font-weight-bold">
              {{ wordList.lbl_area_regist_confirm }}
            </v-card-title>
            <v-card-text class="pt-5 confirm-display-text">
              <!-- チェーン名 -->
              <v-row v-if="chainViewFlag" class="mb-2">
                <v-col cols="4" class="font-weight-black">
                  <v-row align="center" dense class="py-2 pl-2" justify="end">
                    {{ wordList.lbl_chain_name }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col>{{ deliveryAreaInput.chain_name }}</v-col>
              </v-row>
              <!-- 店舗名 -->
              <v-row class="mb-2">
                <v-col cols="4" class="font-weight-black">
                  <v-row align="center" dense class="py-2 pl-2" justify="end">
                    {{ wordList.lbl_shop_name }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col>{{ deliveryAreaInput.shop_name }}</v-col>
              </v-row>
              <v-row class="mb-2">
                <!-- エリア名 -->
                <v-col cols="4" class="font-weight-black">
                  <v-row align="center" dense class="py-2 pl-2" justify="end">
                    {{ wordList.lbl_area_name }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col>{{ deliveryAreaInput.area_name }}</v-col>
              </v-row>
              <v-row class="mb-2">
                <!-- エリア名(カナ) -->
                <v-col cols="4" class="font-weight-black">
                  <v-row align="center" dense class="py-2 pl-2" justify="end">
                    {{ wordList.lbl_area_name_kana }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col>{{ deliveryAreaInput.area_name_kana }}</v-col>
              </v-row>
              <!--
            <v-row class="mb-2">
-->
              <!-- 決済方法 -->
              <!--
              <v-col cols="4" class="font-weight-black">
                <v-row align="center" dense class="py-2 pl-2" justify="end">
                  {{ wordList.lbl_payment_method }}
                  <ImportantChip></ImportantChip>
                </v-row>
              </v-col>
              <v-col cols="4">
                {{ deliveryAreaInput.payment_method }}
              </v-col>
            </v-row>
-->
              <!-- 受付可能終了時間 -->
              <v-row class="mb-2">
                <v-col cols="4" class="font-weight-black">
                  <v-row align="center" dense class="py-2 pl-2" justify="end">
                    {{ wordList.lbl_acceptable_end_time }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col>{{ deliveryAreaInput.acceptable_end_time }}</v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="justify-center">
              <!-- 戻るボタン -->
              <v-btn
                variant="flat"
                color="return"
                class="px-16"
                @click="onClickConfirmCancel"
              >
                <v-icon>mdi-arrow-left</v-icon>
                {{ wordList.btn_return }}
              </v-btn>
              <!-- 完了画面ボタン -->
              <v-btn
                variant="flat"
                color="primary"
                class="px-16"
                @click="onClickConfirmEntry"
              >
                <v-icon>mdi-playlist-edit</v-icon>
                <!-- 登録完了画面ボタン -->
                <span v-if="processFlag < 2">{{
                  wordList.btn_regist_complete
                }}</span>
                <!-- 削除完了画面ボタン -->
                <span v-else>{{
                  wordList.btn_delete_complete
                }}</span>
              </v-btn>
            </v-card-actions>
            <v-overlay
              :model-value="overlay"
              class="d-flex align-center justify-center"
            >
              <v-progress-circular
                indeterminate
                size="64"
              ></v-progress-circular>
            </v-overlay>
          </v-card>
        </v-card>
        <!-- } エリア登録確認ダイアログ -->
        <!-- エリア登録完了ダイアログ { -->
        <v-card v-if="displayCompletedDialog" :flat="true">
          <v-card
            v-if="
              createDeliveryAreaMutation !== null &&
              createDeliveryAreaMutation !== undefined
            "
            :flat="true"
          >
            <v-card-title class="mt-3 pb-5 text-h5 font-weight-bold">
              {{ wordList.lbl_area_regist_complete }}
            </v-card-title>
            <v-card-text>
              <v-row class="pt-5">
                <v-col class="font-weight-black">
                  {{ wordList.lbl_area_regist_complete_msg }}
                </v-col>
              </v-row>
              <!-- チェーン名 -->
              <v-row v-if="chainViewFlag" class="ml-5">
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="py-2 pl-2" justify="end">
                    {{ wordList.lbl_chain_name }}
                  </v-row>
                </v-col>
                <v-col cols="9">{{ deliveryAreaInput.chain_name }}</v-col>
              </v-row>
              <!-- 店舗名 -->
              <v-row class="ml-5">
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="py-2 pl-2" justify="end">
                    {{ wordList.lbl_shop_name }}
                  </v-row>
                </v-col>
                <v-col cols="9">{{ deliveryAreaInput.shop_name }}</v-col>
              </v-row>
              <!-- エリア名 -->
              <v-row class="ml-5">
                <v-col cols="3" class="font-weight-black">
                  <v-row align="center" dense class="py-2 pl-2" justify="end">
                    {{ wordList.lbl_area_name }}
                  </v-row>
                </v-col>
                <v-col cols="9">{{ deliveryAreaInput.area_name }}</v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn
                variant="flat"
                class="px-16"
                @click="onClickCompletedGoStart"
              >
                <span>{{
                  wordList.btn_area_regist_return
                }}</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-card>
        <!-- } エリア登録完了ダイアログ -->
        <AlertDialog
          v-model="errdialog"
          :title="wordList.lbl_err_dialog_title"
          :message="errMessage"
          type="error"
        />
      </v-tabs-window-item>
      <!-- tab2 -->
      <!-- 「配達区画登録」タブ -->
      <v-tabs-window-item value="area_regist">
        <form>
          <v-card :flat="true" class="br_1 mt-5">
            <!-- 検索条件入力 { -->
            <v-card-text class="py-3 font-weight-bold bk_gray_3">
              {{ wordList.lbl_search }}
            </v-card-text>
            <v-divider class="mx-4 bk_gray_3" />
            <Form v-slot="{ meta: formMetaUnassigned }">
              <v-card class="py-0" :flat="true">
                <v-card-text class="bk_gray_3 pt-7">
                  <v-row>
                    <!-- チェーンコード -->
                    <v-col v-if="chainViewFlag" sm="6" md="4" class="py-0">
                      <v-autocomplete
                        v-model="chainSelectValues"
                        density="compact"
                        :label="wordList.lbl_chain_name"
                        :items="chainListItems"
                        item-title="name"
                        item-value="chain_code"
                        :placeholder="wordList.plc_selectbox"
                        :error-messages="errorMessages"
                        :no-data-text="wordList.lbl_no_data_text"
                        bg-color="white"
                        return-object
                        variant="outlined"
                        persistent-placeholder
                        @update:model-value="onChangeChain"
                      ></v-autocomplete>
                    </v-col>
                    <!-- 店舗コード -->
                    <v-col cols="12" sm="6" md="4" class="py-0">
                      <Field
                        v-slot="{ errors }"
                        name="shopName"
                        rules="max:100"
                      >
                        <v-autocomplete
                          v-model="shopSelectValues"
                          density="compact"
                          :items="shopListItems"
                          item-title="name"
                          item-value="shop_code"
                          :label="wordList.lbl_shop_name"
                          :placeholder="wordList.plc_selectbox"
                          :no-data-text="wordList.lbl_no_data_text"
                          :error-messages="errors"
                          return-object
                          variant="outlined"
                          persistent-placeholder
                          bg-color="#fff"
                          @update:model-value="onChangeShop"
                        ></v-autocomplete>
                      </Field>
                    </v-col>
                    <!-- 配達エリア -->
                    <v-col cols="12" sm="6" md="4" class="py-0">
                      <Field
                        v-slot="{ errors }"
                        name="areaNameSearch"
                        rules="max:100"
                      >
                        <v-autocomplete
                          v-model="areaSelectValues"
                          density="compact"
                          :items="areaListItems"
                          item-title="area_name"
                          item-value="area_code"
                          :label="wordList.lbl_area_name"
                          :placeholder="wordList.plc_selectbox"
                          :no-data-text="wordList.lbl_no_data_text"
                          :error-messages="errors"
                          return-object
                          variant="outlined"
                          persistent-placeholder
                          bg-color="#fff"
                          @update:model-value="onChangeAreaAtReg"
                        ></v-autocomplete>
                      </Field>
                    </v-col>
                    <!-- 郵便番号 -->
                    <v-col cols="12" sm="6" md="4" class="py-0">
                      <Field
                        v-slot="{ field, errors }"
                        :name="wordList.lbl_zipcode"
                        rules="numeric|min:3"
                        v-model="searchConditionZipCode"
                      >
                        <v-text-field
                          :model-value="field.value ?? searchConditionZipCode"
                          :label="wordList.lbl_zipcode"
                          density="compact"
                          variant="outlined"
                          clearable
                          :error-messages="errors"
                          bg-color="#fff"
                          persistent-placeholder
                          @update:model-value="
                            (val) => {
                              field.onChange(val);
                              searchConditionZipCode = val;
                            }
                          "
                          @blur="field.onBlur"
                        ></v-text-field>
                      </Field>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="pb-5 pt-0 bk_gray_3">
                  <v-spacer></v-spacer>
                  <v-btn
                    variant="flat"
                    color="primary"
                    class="px-16"
                    :disabled="!formMetaUnassigned.valid || searchConditionAreaCode === ''"
                    @click="onClickSearch"
                  >
                    <v-icon>mdi-magnify</v-icon>
                    {{ wordList.lbl_search }}
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </Form>
            <!-- 検索条件入力 } -->
          </v-card>
        </form>
        <!-- 一覧表示  { -->
        <v-card :flat="true" width="100%">
          <input
            ref="fileInput"
            type="file"
            accept="text/csv"
            style="display: none"
            @change="onChangeFileUpload"
          />

          <!-- PCではページネーション・アクション行とテーブルをまとめて中央寄せ、モバイルでは100%幅で表示 -->
          <div class="d-block d-md-flex justify-center">
            <v-sheet
              class="d-block d-md-inline-block"
              min-width="40%"
              elevation="0"
            >
              <!-- 全◯件〜ページネーション〜アクション -->
              <div class="d-flex justify-space-between align-center mt-7 mb-3">
                <div class="d-flex align-center">
                  <span class="pl-3"> 全 {{ listDataTotalCount }} 件 </span
                  ><span class="pl-1"> {{ displayPagingRangeUnassigned }} </span>
                  <v-pagination
                    v-model="unassignedListOptions.page"
                    :length="pageCount"
                    :total-visible="7"
                    variant="elevated"
                    density="comfortable"
                  ></v-pagination>
                </div>
                <v-menu open-on-hover location="bottom">
                  <template #activator="{ props }">
                    <v-btn variant="text" color="black" v-bind="props">
                      アクション
                      <v-icon>mdi-cog</v-icon>
                    </v-btn>
                  </template>
                  <v-list width="250" class="pl-5">
                    <v-list-item-title
                      style="cursor: pointer"
                      @click="onClickCheckUnassignedSection"
                    >
                      <v-icon class="mr-2">mdi-import</v-icon>
                      <!-- 一括登録 -->
                      {{ wordList.lbl_bulk_add }}
                    </v-list-item-title>
                    <v-list-item-title
                      style="cursor: pointer"
                      @click="fileInput?.click()"
                    >
                      <v-icon class="mr-2 mb-1">mdi-cloud-upload</v-icon>
                      <!-- 一括登録 -->
                      {{ wordList.lbl_csv_upload_delivery_area_section }}
                    </v-list-item-title>
                  </v-list>
                </v-menu>
              </div>

              <!-- テーブル本体 -->
              <v-data-table-server
                :model-value="selectListCheckbox"
                item-key="lot_code"
                item-value="lot_code"
                :items-per-page="unassignedListOptions.itemsPerPage"
                :items-length="listDataTotalCount"
                :options="unassignedListOptions"
                :items="listAreaSectionUnassigned"
                :loading="listLoading"
                hide-default-footer
                show-select
                :headers="tableUnassignedListHeaders"
                :no-data-text="wordList.lbl_no_data_text"
                @update:model-value="onSelectionChange"
                @update:options="onUpdateUnassignedOptions"
              >
                <template #[`item.actions`]="{ item }">
                  <div>
                    <v-btn
                      variant="outlined"
                      icon
                      color="primary"
                      class="my-2 ml-2"
                      size="x-small"
                      rounded="circle"
                      @click="onClickEdit(item.lot_code)"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>

                    <v-btn
                      variant="outlined"
                      icon
                      color="red"
                      class="my-2 ml-2 mr-0"
                      size="x-small"
                      rounded="circle"
                      @click="onClickDelete(item)"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </template>
              </v-data-table-server>
            </v-sheet>
          </div>
        </v-card>
        <!-- 配達区画登録確認ダイアログ { -->
        <v-dialog
          v-model="displayConfirmDialogSectionUnassigned"
          width="50%"
          scrollable
        >
          <v-card>
            <v-card-title class="bg-primary mb-5" style="color: white">
              配達区画登録確認
            </v-card-title>
            <div class="font-weight-black px-4 py-2">
              {{ selectedUnassignedItems.length }}
              件の配達区画を登録します。
            </div>
            <v-card-text>
              <v-card v-for="item in selectedUnassignedItems" :key="item.lot_code" class="mb-5">
                <v-list density="compact">
                  <v-list-item>
                    <v-list-item-title>
                      郵便番号: {{ item.zip_code }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>
                      配達区画: {{ item.delivery_area_section }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-card-text>
            <v-card-actions>
              <v-row justify="center">
                <!-- 戻るボタン -->
                <v-btn
                  variant="flat"
                  color="return"
                  class="px-16 mr-5"
                  @click="displayConfirmDialogSectionUnassigned = false"
                >
                  <v-icon>mdi-arrow-left</v-icon>
                  {{ wordList.btn_return }}
                </v-btn>
                <v-btn
                  variant="outlined"
                  class="bg-primary px-16 mb-3"
                  color="white"
                  width="50%"
                  @click="onClickSectionUnassignedComplete"
                >
                  <!-- 一括登録 -->
                  {{ wordList.lbl_bulk_add }}
                </v-btn>
              </v-row>
            </v-card-actions>
            <v-overlay
              :model-value="overlay"
              class="d-flex align-center justify-center"
            >
              <v-progress-circular
                indeterminate
                size="64"
              ></v-progress-circular>
            </v-overlay>
          </v-card>
        </v-dialog>
        <!-- } 配達区画登録確認ダイアログ -->
        <AlertDialog
          v-model="messagedialog"
          :title="wordList.lbl_delivery_regist"
          :message="message"
          type="info"
        />
        <!-- } ダイアログ -->
        <!-- アップロード中 ダイアログ { -->
        <v-dialog v-model="uploadDialog" persistent width="40%">
          <v-card>
            <v-card-title>アップロード</v-card-title>
            <v-card-text>
              <v-container style="height: 200px">
                <v-row
                    class="fill-height"
                  align-content="center"
                  justify="center"
                >
                  <v-col class="text-subtitle-1 text-center" cols="12">
                    アップロード中...
                  </v-col>
                  <v-col cols="6">
                    <v-progress-linear
                      color="deep-purple-accent-4"
                      indeterminate
                      rounded
                      height="6"
                    ></v-progress-linear>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- } アップロード中 ダイアログ -->
      </v-tabs-window-item>
      <!-- tab3 -->
      <!-- 「配達区画一覧」タブ -->
      <v-tabs-window-item value="delivery_lot_regist">
        <form>
          <v-card :flat="true" class="br_1 mt-5">
            <!-- 検索条件入力 { -->
            <v-card-text class="py-3 font-weight-bold bk_gray_3">
              {{ wordList.lbl_search }}
            </v-card-text>
            <v-divider class="mx-4 bk_gray_3" />
            <Form v-slot="{ meta: formMetaAssigned }">
              <v-card class="py-0" :flat="true">
                <v-card-text class="bk_gray_3 pt-7">
                  <v-row>
                    <!-- チェーンコード -->
                    <v-col v-if="chainViewFlag" sm="6" md="4" class="py-0">
                      <v-autocomplete
                        v-model="chainSelectValues"
                        density="compact"
                        :label="wordList.lbl_chain_name"
                        :items="chainListItems"
                        item-title="name"
                        item-value="chain_code"
                        :placeholder="wordList.plc_selectbox"
                        :error-messages="errorMessages"
                        :no-data-text="wordList.lbl_no_data_text"
                        bg-color="white"
                        return-object
                        variant="outlined"
                        persistent-placeholder
                        @update:model-value="onChangeChain"
                      ></v-autocomplete>
                    </v-col>
                    <!-- 店舗コード -->
                    <v-col cols="12" sm="6" md="4" class="py-0">
                      <Field
                        v-slot="{ errors }"
                        name="shopNameAssigned"
                        rules="max:100"
                      >
                        <v-autocomplete
                          v-model="shopSelectValues"
                          density="compact"
                          :items="shopListItems"
                          item-title="name"
                          item-value="shop_code"
                          :label="wordList.lbl_shop_name"
                          :placeholder="wordList.plc_selectbox"
                          :no-data-text="wordList.lbl_no_data_text"
                          :error-messages="errors"
                          return-object
                          variant="outlined"
                          persistent-placeholder
                          bg-color="#fff"
                          @update:model-value="onChangeShop"
                        ></v-autocomplete>
                      </Field>
                    </v-col>
                    <!-- 配達エリア -->
                    <v-col cols="12" sm="6" md="4" class="py-0">
                      <Field
                        v-slot="{ errors }"
                        name="areaNameAssigned"
                        rules="max:100"
                      >
                        <v-autocomplete
                          v-model="areaSelectValuesSectionAssigned"
                          density="compact"
                          :items="areaListItemsSectionAssigned"
                          item-title="area_name"
                          item-value="area_code"
                          :label="wordList.lbl_area_name"
                          :placeholder="wordList.plc_selectbox"
                          :no-data-text="wordList.lbl_no_data_text"
                          :error-messages="errors"
                          return-object
                          variant="outlined"
                          persistent-placeholder
                          bg-color="#fff"
                          @update:model-value="onChangeAreaAtList"
                        ></v-autocomplete>
                      </Field>
                    </v-col>
                    <!-- 郵便番号 -->
                    <v-col cols="12" sm="6" md="4" class="py-0">
                      <Field
                        v-slot="{ field, errors }"
                        :name="wordList.lbl_zipcode"
                        rules="numeric|min:3"
                        v-model="searchConditionZipCodeSectionAssigned"
                      >
                        <v-text-field
                          :model-value="field.value ?? searchConditionZipCodeSectionAssigned"
                          :label="wordList.lbl_zipcode"
                          density="compact"
                          variant="outlined"
                          clearable
                          :error-messages="errors"
                          bg-color="#fff"
                          persistent-placeholder
                          @update:model-value="
                            (val) => {
                              field.onChange(val);
                              searchConditionZipCodeSectionAssigned = val;
                            }
                          "
                          @blur="field.onBlur"
                        ></v-text-field>
                      </Field>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions class="pb-5 pt-0 bk_gray_3">
                  <v-spacer></v-spacer>
                  <v-btn
                    variant="flat"
                    color="primary"
                    class="px-16"
                    :disabled="!formMetaAssigned.valid || searchConditionAreaCode === ''"
                    @click="onClickSearchAssigned"
                  >
                    <v-icon>mdi-magnify </v-icon>
                    {{ wordList.lbl_search }}
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </Form>
            <!-- 検索条件入力 } -->
          </v-card>
        </form>
        <!-- 一覧表示  { -->
        <v-card :flat="true" width="100%">
          <!-- PCではページネーション・アクション行とテーブルをまとめて中央寄せ、モバイルでは100%幅で表示 -->
          <div class="d-block d-md-flex justify-center">
            <v-sheet
              class="d-block d-md-inline-block"
              min-width="40%"
              elevation="0"
            >
              <!-- 全◯件〜ページネーション〜アクション -->
              <div class="d-flex justify-space-between align-center mt-7 mb-3">
                <div class="d-flex align-center">
                  <span class="pl-3"
                    >全 {{ listDataTotalCountSectionAssigned }} 件
                  </span
                  ><span class="pl-1"> {{ displayPagingRangeAssigned }} </span>
                  <v-pagination
                    v-model="assignedListOptions.page"
                    :length="pageCountSectionAssigned"
                    :total-visible="7"
                    variant="elevated"
                    density="comfortable"
                  ></v-pagination>
                </div>
                <v-menu open-on-hover location="bottom">
                  <template #activator="{ props }">
                    <v-btn variant="text" color="black" v-bind="props">
                      アクション
                      <v-icon>mdi-cog</v-icon>
                    </v-btn>
                  </template>
                  <v-list width="280" class="pl-5">
                    <v-list-item-title
                      class="mb-3"
                      style="cursor: pointer"
                      @click="onClickDownloadAssignedSection"
                    >
                      <v-icon class="mr-2 mb-1">mdi-cloud-download</v-icon>
                      <!-- 配達区画ダウンロード -->
                      {{ wordList.lbl_delivery_lot_list_download }}
                    </v-list-item-title>
                    <v-list-item-title
                      style="cursor: pointer"
                      @click="onClickCheckAssignedSection"
                    >
                      <v-icon class="mr-2">mdi-delete</v-icon>
                      <!-- 一括削除 -->
                      {{ wordList.lbl_bulk_delete }}
                    </v-list-item-title>
                  </v-list>
                </v-menu>
              </div>

              <!-- テーブル本体 -->
              <v-data-table-server
                :model-value="selectListCheckboxSectionAssigned"
                item-key="lot_code"
                item-value="lot_code"
                :items-per-page="assignedListOptions.itemsPerPage"
                :items-length="listDataTotalCountSectionAssigned"
                :options="assignedListOptions"
                :items="listAreaSectionAssigned"
                :loading="listLoading"
                hide-default-footer
                show-select
                :headers="tableUnassignedListHeaders"
                :no-data-text="wordList.lbl_no_data_text"
                @update:model-value="onSelectionChangeAssigned"
                @update:options="onUpdateAssignedOptions"
              >
                <template #[`item.actions`]="{ item }">
                  <div>
                    <v-btn
                      variant="outlined"
                      icon
                      color="primary"
                      class="my-2 ml-2"
                      size="x-small"
                      rounded="circle"
                      @click="onClickEdit(item.lot_code)"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>

                    <v-btn
                      variant="outlined"
                      icon
                      color="red"
                      class="my-2 ml-2 mr-0"
                      size="x-small"
                      rounded="circle"
                      @click="onClickDelete(item)"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </template>
              </v-data-table-server>
            </v-sheet>
          </div>
        </v-card>
        <!-- 配達区画削除確認ダイアログ { -->
        <v-dialog
          v-model="displayConfirmDialogSectionAssigned"
          width="50%"
          scrollable
        >
          <v-card>
            <v-card-title class="bg-red mb-5" style="color: white">
              配達区画削除確認
            </v-card-title>
            <div class="font-weight-black px-4 py-2">
              {{ selectedAssignedItems.length }}
              件の配達区画を削除します。
            </div>
            <v-card-text>
              <v-card v-for="item in selectedAssignedItems" :key="item.lot_code" class="mb-5">
                <v-list density="compact">
                  <v-list-item>
                    <v-list-item-title>
                      郵便番号: {{ item.zip_code }}
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>
                      配達区画: {{ item.delivery_area_section }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-card-text>
            <v-card-actions>
              <v-row justify="center">
                <!-- 戻るボタン -->
                <v-btn
                  variant="flat"
                  color="return"
                  class="px-16 mr-5"
                  @click="displayConfirmDialogSectionAssigned = false"
                >
                  <v-icon>mdi-arrow-left</v-icon>
                  {{ wordList.btn_return }}
                </v-btn>
                <v-btn
                  variant="outlined"
                  class="bg-red px-16 mb-3"
                  color="white"
                  width="50%"
                  @click="onClickSectionAssignedComplete"
                >
                  {{ wordList.lbl_bulk_delete }}
                </v-btn>
              </v-row>
            </v-card-actions>
            <v-overlay
              :model-value="overlay"
              class="d-flex align-center justify-center"
            >
              <v-progress-circular
                indeterminate
                size="64"
              ></v-progress-circular>
            </v-overlay>
          </v-card>
        </v-dialog>
        <!-- } 配達区画削除確認ダイアログ -->
        <!-- 配達区画ダウンロードダイアログ { -->
        <v-dialog v-model="displayDialogDownloadSectionAssigned" width="40%" scrollable>
          <v-card>
            <v-card-title>配達区画をダウンロード</v-card-title>
            <v-card-text class="text-red">
              ※住所の改廃等により廃止となった配達区画はダウンロードされません。
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn
                variant="outlined"
                class="bg-blue px-16 mb-3"
                color="white"
                @click="onClickDownloadAssignedComplete"
              >
                OK
              </v-btn>
            </v-card-actions>

            <v-overlay
              :model-value="overlay"
              contained
              class="d-flex align-center justify-center"
            >
              <v-progress-circular indeterminate size="64" />
            </v-overlay>
          </v-card>
        </v-dialog>
        <!-- } 配達区画ダウンロードダイアログ -->
      </v-tabs-window-item>
    </v-tabs-window>
  </v-container>
</template>

<script setup lang="ts">
import { ref, reactive, watch, onMounted } from 'vue';
import { Form, Field, defineRule, configure } from "vee-validate";
import { localize, setLocale } from "@vee-validate/i18n";
import { required, max, min, numeric, regex } from "@vee-validate/rules";
import ja from "@vee-validate/i18n/dist/locale/ja.json";
import ImportantChip from "@/components/ImportantChip.vue";
import AlertDialog from "@/components/AlertDialog.vue";
import type { ChainPaymentMethod } from "@/generated/graphql";
import {
  localStorageGetCustomerCode,
  localStorageGetUserId,
  localStorageGetAuthType,
} from "@/common/localStorageUtil";
import { checkChainListDisplay } from "@/common/business";
import type { DeliveryAreaInput, UnassignedSection, AssignedSection } from "./types";
import { TABLE_HEADERS, TABLE_UNASSIGNED_LIST_HEADERS } from "./constants";
import { useAreaListUiState } from "./composables/useAreaListUiState";
import { useAreaListFilterOptions } from "./composables/useAreaListFilterOptions";
import { useAreaListInit } from "./composables/useAreaListInit";
import { useAreaListAreaCrud } from "./composables/useAreaListAreaCrud";
import { useAreaListSectionUnassigned } from "./composables/useAreaListSectionUnassigned";
import { useAreaListSectionAssigned } from "./composables/useAreaListSectionAssigned";
import { useAreaListDownload } from "./composables/useAreaListDownload";
import { useAreaListUpload } from "./composables/useAreaListUpload";

// --- vee-validate rules ---

defineRule("required", required);
defineRule("max", max);
defineRule("min", min);
defineRule("numeric", numeric);
defineRule("regex", regex);
defineRule("time_format", (value: unknown): true | string => {
  if (value === null || value === undefined || value === "") {
    return true;
  }
  const text = String(value);
  return /^([01]\d|2[0-3]):[0-5]\d$/.test(text)
    || "時刻はhh:mm形式で入力してください。";
});
configure({
  generateMessage: localize({ ja }),
});
setLocale("ja");

// --- テーブルヘッダー定義 ---
const tableHeaders = TABLE_HEADERS;
const tableUnassignedListHeaders = TABLE_UNASSIGNED_LIST_HEADERS;

// --- 共有 state（複数composable間で参照されるため index.vue で作成） ---

// エリア登録 input
const deliveryAreaInput = reactive<DeliveryAreaInput>({
  area_code: "",
  area_name: "",
  area_name_kana: "",
  chain_code: "",
  chain_name: "",
  customer_code: localStorageGetCustomerCode(),
  shop_code: "",
  shop_name: "",
  payment_method: "",
  acceptable_end_time: "",
  user_id: localStorageGetUserId(),
});

// 決済方法
const paymentMethodItems = ref<ChainPaymentMethod[]>([]);

// ユーザ権限
const chainViewFlag = ref(checkChainListDisplay(localStorageGetAuthType()));

// ローディング状態（Tab2/Tab3共通）
const listLoading = ref(false);

// 未登録配達区画タブ state
const listAreaSectionUnassigned = ref<UnassignedSection>([]);
const selectListCheckbox = ref<string[]>([]);
const searchConditionZipCode = ref<string | null>(null);
const listDataTotalCount = ref(0);
const displayPagingRangeUnassigned = ref("");

// 登録済配達区画タブ state
const listAreaSectionAssigned = ref<AssignedSection>([]);
const selectListCheckboxSectionAssigned = ref<string[]>([]);
const searchConditionZipCodeSectionAssigned = ref<string | null>(null);
const listDataTotalCountSectionAssigned = ref(0);
const displayPagingRangeAssigned = ref("");

// --- composables ---

// 1. UI状態管理
const {
  tab,
  errdialog,
  errMessage,
  overlay,
  processFlag,
  displayInputDialog,
  displayConfirmDialog,
  displayCompletedDialog,
  displayConfirmDialogSectionUnassigned,
  displayConfirmDialogSectionAssigned,
  displayDialogDownloadSectionAssigned,
  uploadDialog,
  messagedialog,
  message,
} = useAreaListUiState();

// 2. フィルタ・選択肢管理
const {
  chainListItems,
  chainSelectValues,
  shopListItems,
  shopSelectValues,
  shopListInput,
  errorMessages,
  listArea,
  areaListItems,
  areaSelectValues,
  areaListItemsSectionAssigned,
  areaSelectValuesSectionAssigned,
  searchConditionAreaCode,
  onChangeChain,
  onChangeShop,
  onChangeAreaAtReg,
  onChangeAreaAtList,
  onClickLotRegistTab,
} = useAreaListFilterOptions({
  errdialog,
  errMessage,
  deliveryAreaInput,
  paymentMethodItems,
  listAreaSectionUnassigned,
  listAreaSectionAssigned,
  displayConfirmDialogSectionUnassigned,
  displayConfirmDialogSectionAssigned,
  selectListCheckboxSectionAssigned,
  listDataTotalCount,
  displayPagingRangeUnassigned,
  listDataTotalCountSectionAssigned,
  displayPagingRangeAssigned,
  searchConditionZipCode,
  searchConditionZipCodeSectionAssigned,
});

// 3. 初期ロード
const {
  wordList,
  isWordListReady,
  runInitialLoad,
} = useAreaListInit({
  errdialog,
  errMessage,
  chainListItems,
  chainSelectValues,
  shopListItems,
  shopListInput,
  deliveryAreaInput,
  paymentMethodItems,
  chainViewFlag,
});

// 4. エリアCRUD
const {
  createDeliveryAreaMutation,
  onClickNewRegister,
  onClickEdit,
  onClickDelete,
  onClickInputCancel,
  onClickOpenConfirmDialog,
  onClickConfirmEntry,
  onClickConfirmCancel,
  onClickCompletedGoStart,
} = useAreaListAreaCrud({
  errdialog,
  errMessage,
  overlay,
  processFlag,
  displayInputDialog,
  displayConfirmDialog,
  displayCompletedDialog,
  chainSelectValues,
  shopSelectValues,
  listArea,
  paymentMethodItems,
  deliveryAreaInput,
  onChangeShop,
});

// 5. 未登録配達区画
const {
  selectedUnassignedItems,
  pageCount,
  unassignedListOptions,
  onUpdateUnassignedOptions,
  onClickSearch,
  onClickCheckUnassignedSection,
  onClickSectionUnassignedComplete,
  onSelectionChange,
} = useAreaListSectionUnassigned({
  errdialog,
  errMessage,
  overlay,
  displayConfirmDialogSectionUnassigned,
  areaSelectValues,
  shopSelectValues,
  deliveryAreaInput,
  listAreaSectionUnassigned,
  selectListCheckbox,
  searchConditionZipCode,
  listLoading,
  listDataTotalCount,
  displayPagingRangeUnassigned,
});

// 6. 登録済配達区画
const {
  selectedAssignedItems,
  pageCountSectionAssigned,
  assignedListOptions,
  onUpdateAssignedOptions,
  onClickSearchAssigned,
  onClickCheckAssignedSection,
  onClickSectionAssignedComplete,
  onSelectionChangeAssigned,
} = useAreaListSectionAssigned({
  errdialog,
  errMessage,
  overlay,
  displayConfirmDialogSectionAssigned,
  areaSelectValuesSectionAssigned,
  shopSelectValues,
  chainSelectValues,
  deliveryAreaInput,
  listLoading,
  listAreaSectionAssigned,
  selectListCheckboxSectionAssigned,
  searchConditionZipCodeSectionAssigned,
  listDataTotalCountSectionAssigned,
  displayPagingRangeAssigned,
});

// 7. CSVダウンロード
const {
  onClickDownloadAssignedSection,
  onClickDownloadAssignedComplete,
} = useAreaListDownload({
  errdialog,
  errMessage,
  overlay,
  displayDialogDownloadSectionAssigned,
  areaSelectValuesSectionAssigned,
  shopSelectValues,
  chainSelectValues,
  deliveryAreaInput,
  listAreaSectionAssigned,
  searchConditionZipCodeSectionAssigned,
});

// 8. CSVアップロード
const {
  fileInput,
  onChangeFileUpload,
} = useAreaListUpload({
  overlay,
  uploadDialog,
  messagedialog,
  message,
  chainSelectValues,
});

// --- タブ変更時 ---
watch(tab, async (newVal) => {
  if (newVal === 'area_regist') {
    // 「配達区画登録」タブをクリックしたとき
    await onClickLotRegistTab(1);
  } else if (newVal === 'delivery_lot_regist') {
    // 「配達区画一覧」タブをクリックしたとき
    await onClickLotRegistTab(2);
  }
});

// --- lifecycle ---
onMounted(async () => {
  searchConditionAreaCode.value = "";
  await runInitialLoad();
});
</script>

<style scoped></style>
